class ListMenu {
    menuList: HTMLElement | null;
    menuButton: HTMLElement | null;
    search: HTMLElement | null;
    timeoutId: number | null = null;

    constructor() {
        this.menuList = document.querySelector('.menu__list');
        this.menuButton = document.querySelector('.menu__button');
        this.search = document.querySelector('.menu .search');

        if (this.menuList && this.menuButton) {
            this.onHover();
            this.handleOutsideClick();
            this.handleResize();
        }
    }

    onHover() {
        if (!this.menuList || !this.menuButton) return;

        const isMobile = () => window.matchMedia('(max-width: 991.98px)').matches;

        const showMenu = () => {
            if (this.timeoutId) clearTimeout(this.timeoutId);

            this.menuList!.classList.add('active');

            if (isMobile()) {
                this.search!.classList.add('active');
            }
        };

        const hideMenu = () => {
            this.timeoutId = window.setTimeout(() => {
                this.menuList!.classList.remove('active');


                if (isMobile()) {
                    this.search!.classList.remove('active');
                }
            }, 200);
        };

        this.menuButton.addEventListener('mouseenter', showMenu);
        this.menuButton.addEventListener('mouseleave', hideMenu);
        this.menuList.addEventListener('mouseenter', showMenu);
        this.menuList.addEventListener('mouseleave', hideMenu);

        this.search?.addEventListener('mouseenter', () => {
            if (this.search?.classList.contains('active')) {
                showMenu();
            }
        });
    }

    handleOutsideClick() {
        document.addEventListener('click', (e) => {
            const target = e.target as Node;

            if (
                !this.menuList?.contains(target) &&
                !this.search?.contains(target) &&
                !this.menuButton?.contains(target)
            ) {
                if (this.timeoutId) clearTimeout(this.timeoutId);

                this.menuList?.classList.remove('active');
                this.search?.classList.remove('active');
            }
        });
    }

    handleResize() {
        const isMobile = () => window.matchMedia('(max-width: 991.98px)').matches;

        window.addEventListener('resize', () => {
            if (!isMobile()) {
                this.search?.classList.remove('active');
            }
        });
    }
}

export const listMenu = new ListMenu();
